import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function BatchReading() {
  const { barangayId } = useParams();
  const navigate = useNavigate();
  const [consumers, setConsumers] = useState([]);
  const [barangay, setBarangay] = useState(null);
  const [readingDate, setReadingDate] = useState(new Date().toISOString().slice(0, 10));
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/readings/batch_consumers/${barangayId}`).then(r => {
      setConsumers(r.data.consumers);
      setBarangay(r.data.barangay);
    });
  }, [barangayId]);

  const handleSave = async () => {
    const readings = Object.entries(values)
      .filter(([, v]) => v.trim())
      .map(([id, v]) => ({ consumer_id: parseInt(id), meter_reading: parseInt(v) }));
    if (!readings.length) return alert('No readings to submit');
    setSaving(true);
    try {
      const r = await api.post('/readings/batch', { reading_date: readingDate, readings });
      alert(r.data.message);
      navigate('/readings');
    } catch (e) { alert('Error: ' + e.message); }
    setSaving(false);
  };

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{margin:0}}>Batch Reading - {barangay?.name}</h1>
        <button className="btn btn-success" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save All'}</button>
      </div>
      <div className="card mb-16" style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
        <label>Reading Date:</label>
        <input className="input" type="date" style={{width:180}} value={readingDate} onChange={e => setReadingDate(e.target.value)} />
        <span style={{color:'#666'}}>{consumers.length} consumers</span>
      </div>
      {consumers.map(c => (
        <div key={c.id} className="card" style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 12 }}>
          <div style={{ flex: 1 }}>
            <strong>{c.name}</strong>
            <div style={{color:'#666', fontSize:12}}>{c.account_code}</div>
            {c.last_reading != null && <div style={{color:'#999', fontSize:11}}>Last: {c.last_reading} ({c.last_reading_date})</div>}
          </div>
          <input className="input" style={{width:120}} type="number" placeholder="Reading"
            value={values[c.id] || ''} onChange={e => setValues(v => ({...v, [c.id]: e.target.value}))} />
        </div>
      ))}
    </div>
  );
}
